import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import {
  AccountTransfersBillingResponseItem,
  AccountTransfersBillingTableData,
  AccountTransfersBillingTableRowActions
} from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: AccountTransfersBillingResponseItem[],
  actions: AccountTransfersBillingTableRowActions
): AccountTransfersBillingTableData[] =>
  data.map((accountTransfersBillingItem: AccountTransfersBillingResponseItem) => {
    const { cost, transferAmount, id, ...rest } = accountTransfersBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      transferAmount: transferAmount.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
